if (!customElements.get('scrolling-banner')) {
  const ScrollingBanner = class extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      // Transforms can confuse lazy loading in browsers, so we coordinate loading here
      // Load all countdown timers
      customElements.whenDefined('countdown-timer').then(() => {
        this.querySelectorAll('countdown-timer').forEach((el) => el.init());
      });

      // Load all images
      this.querySelectorAll('img[loading="lazy"]').forEach((el) => {
        el.loading = 'eager';
      });

      // After fonts have loaded
      // Buchan: start after fonts load, but never wait longer than 500ms. On a
      // first visit iOS can take many seconds to report "all fonts ready"
      // (third-party font kits), and the strip stayed blank until then.
      const start = () => this.querySelector('.marquee').classList.add('marquee--animate');
      Promise.race([document.fonts.ready, new Promise((r) => setTimeout(r, 500))]).then(start, start);
    }
  };

  window.customElements.define('scrolling-banner', ScrollingBanner);
}
